<div class="bg-page flex h-full items-start justify-center gap-2 p-6">
  <div
    class="from-card to-muted border-line flex w-1/3 flex-col items-center gap-4 rounded-2xl border bg-linear-to-tr p-8"
  >
    <h1 class="text-fg text-3xl font-light">
      {{ 'routes.public.redirect.title' | transloco }}
    </h1>
    @defer {
    <edu-loader size="lg" />
    }
    <p class="text-fg-muted text-sm">
      {{ 'routes.public.redirect.subtitle' | transloco }}
    </p>
  </div>
</div>
